import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Host,
  HostBinding,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  SkipSelf,
  TemplateRef,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { FormFieldComponent } from './form-field.component';
import { FormControl } from '../models/FormControl';
import { untilDestroyed } from '@azora/common';


@Component({
  selector: 'form-feedback',
  template: `

  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFeedbackComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  ///-----------------------------------------------  Variables   -----------------------------------------------///
  
  /**
   * @description
   * The parent  for the containers
   *
   * @internal
   */
  
  _parent: FormFieldComponent;
  
  
  template: TemplateRef<any> = null;
  
  @HostBinding('class.form-feedback') setClass = true;
  
  
  @Output() change = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Output() enter = new EventEmitter();
  @Output() focus = new EventEmitter();
  
  ///-----------------------------------------------  Life Cycle Hook   -----------------------------------------------///
  
  
  constructor(
    private cd: ChangeDetectorRef,
    private _vcRef: ViewContainerRef,
    @Optional() @Host() @SkipSelf() parent: FormFieldComponent
  ) {
    this._parent = parent;
    
  }
  
  ngOnInit(): void {
    this._parent.control.statusChanges
      .pipe(untilDestroyed(this))
      .subscribe(status => {
        this.cd.detectChanges();
      });
    
    this._parent.root.ngSubmit
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        this.cd.detectChanges();
      });
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    // this.cd.detectChanges();
  }
  
  ngAfterViewInit(): void {
  
  }
  
  ngOnDestroy(): void {
  }
  
  get control(): FormControl {
    return this._parent.control;
  };
  
  get invalid(): Boolean {
    return this.control.invalid && (this.control.dirty || this.control.touched || this._parent.root.submitted);
  };
  
}
